
<div class="page-container">
  <div  class='main-container' *ngIf='!(startingAssessment$ | async); else startingAssessment'>
    <h2 class="mat-headline bold text-center">
      Please select the assessment category you would like to take.
    </h2>
    <div class="assessment-cat-container">
      <mat-progress-bar mode="indeterminate" *ngIf="loadingAssessments$ | async"></mat-progress-bar>
      <div *ngFor='let assessment of allAssessments' class='mat-elevation-z3 assessment'>
          <div class='assessment-title'>
            <mat-icon >{{ assessment.icon }}</mat-icon>{{ assessment.name | titlecase }}
            </div>
            <div class="button">
              <button  mat-button (click)="startAssessment(assessment)" color="primary">
                Start</button>
          </div>
        </div>
      </div>
  </div>

  <ng-template #startingAssessment>
    <div fxLayout='column' fxFlexFill fxLayoutAlign='center center'>
      <mat-spinner></mat-spinner>
      <h3>Setting up assessment.</h3>
    </div>
  </ng-template>
</div>

